var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main animated fadeIn faster",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c('div',{staticClass:"contenedor py-0"},[_c('div',{staticClass:"row px-0 py-0"},[_c('div',{staticClass:"col-12 px-2 py-0"},[_c('OliverSales')],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }